export default __webpack_public_path__ + "static/cashflow_new_5-742c9efea92b144cce23665cac79d72c.jpg";